export const environment = {
  // Build configuration
  production: false,
  // Feature flags
  serviceWorkerEnabled: true,
  modernFrameDocumentLoadTimeoutMs: 15_000,
  oneFrontDoorRequestSystemsEnabled: true,
  modernFrameRoutesEnabled: true,
  megaboardEnabled: true,

  // Service endpoints and application settings
  urlApiManagement: 'https://dev-ms-mgmt-container.politewater-8bc3d0da.eastus2.azurecontainerapps.io',
  urlProfileManagement: 'https://dev-ms-profile-mgmt-container.politewater-8bc3d0da.eastus2.azurecontainerapps.io',
  urlStp: 'https://dev-ms-stp-container.politewater-8bc3d0da.eastus2.azurecontainerapps.io',
  urlTaskManagement: 'https://dev-ms-task-management-container.politewater-8bc3d0da.eastus2.azurecontainerapps.io',
  urlVendorManagement: 'https://dev-ms-vendor-mgmt-container.politewater-8bc3d0da.eastus2.azurecontainerapps.io',
  urlSuperClients: 'https://dev-ms-super-clients-container.politewater-8bc3d0da.eastus2.azurecontainerapps.io',
  urlProjectManagement: 'https://dev-ms-project-mgmt-container.politewater-8bc3d0da.eastus2.azurecontainerapps.io',
  urlJiraProject: 'https://qa-ms-jira-project-container.politewater-8bc3d0da.eastus2.azurecontainerapps.io',
  redirectUri: 'https://qa-am-operationmgt.nttltd.global.ntt/home',
  clarityKey: 'o2w9i76nmh',
  urlMegaboard: 'https://dev-ms-megaboard-api.azurewebsites.net'
};
